import React, { useEffect, useState } from 'react';
import Particles from 'react-particles-js';
import { useThemeData } from '../../hooks/ThemeData';

interface IProps {
    particles ?: string;
    particlesSize ?: number;
    particlesColor ?: string;
    particlesQuantity ?: number;
    particlesDirection ?: "top" | "top-right" | "top-left" | "right" | "bottom" | "left" | "bottom-right";
    particlesSpeed  ?: number;
    particlesImage ?: string;
}

const ParticlesComponent : React.FC = () => {

    const {theme} = useThemeData();

    const [config,setConfig] = useState<IProps>(theme);

    useEffect(() => {
       setConfig(theme);
    },[theme])

    return config?.particles === "2" ? <Particles
    params={{
      particles: {
        lineLinked: {
          enable: false,
        },
        move: {
          speed: 1,
          direction: 'top-right',
          collisions: false,
          outModes: {
            default: 'out',
            left: 'out',
            right: 'out',
            bottom: 'out',
            top: 'out',
          },

         
        },
        opacity: {
          value: 0.4,
          random: false,
          animation: {
            enable: false
          }

        },
        shape: {
          type: 'image',
          polygon: {
           
            nb_sides: 6,
            
          },
          image: {
            src: "/apoio/cross.png",
            width: 50,
            height: 50
          }
        },
 
        color: { value: 'rgb(0,100,200)' },

        number: {
          density: {
            enable: true,
            value_area: 2400,
          },
          value: 60,
        },
        size: {
          value: 12,
          random: true,
        },
      },
    }}
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '100%',
      zIndex: 1
    }}
  />
  : <></>
}

export default ParticlesComponent;